// PicDict UI (claude.ai/design) の配色・タイポグラフィをそのまま定数化したもの。
// 各ページのsxはここから参照し、色を一箇所で管理する。
export const colors = {
  bg: "#F2F0EC",
  bgSoft: "#F8F7F3",
  bgSearch: "#EDEBE7",
  card: "#FDFCF9",
  border: "#E4E1DB",
  borderSoft: "#DAD7D2",

  textPrimary: "#241E1A",
  textLabel: "#514C47",
  textSecondary: "#67625D",
  textMuted: "#8A8580",
  textFaint: "#A39D98",

  // favicon(PD.png)のロゴから抽出したブランドブルー
  accent: "#0E69E9",
  accentRgb: "14,105,233",
  accentDark: "#0247A8",
  accentDarkRgb: "2,71,168",
  accentSoft: "#EAF0F8",
  accentSoftBorder: "#D7E4F6",

  danger: "#ef4444",
  dangerSoft: "#fef2f2",
  answerCorrectBg: "#dcfce7",
  answerCorrectBorder: "#86efac",
  answerCorrectText: "#166534",
  answerWrongBg: "#fee2e2",
  answerWrongBorder: "#fca5a5",
  answerWrongText: "#991b1b",
} as const;

export const fontFamily =
  "'Schibsted Grotesk','Zen Kaku Gothic New',system-ui,sans-serif";
export const monoFontFamily = "'JetBrains Mono',monospace";
